import ApiExamSign from './api-exam-sign';
import ApiExamResult from './api-exam-result';
import ApiArticle from './api-article';
import ApiOss from './api-oss';
import ApiCommon from './api-common';
import ApiPay from './api-pay';
import ApiUser from './api-user';
import ApiEnroll from './api-enroll';
import ApiExpress from './api-express';
import ApiRefund from './api-refund';

export default { ApiArticle, ApiExamSign, ApiOss, ApiCommon, ApiPay, ApiUser, ApiEnroll, ApiExamResult, ApiExpress, ApiRefund };
